export default __webpack_public_path__ + "static/hero_partner-aaa31f4f5e5df4ea2a94691bb65fdafb.jpg";